import $ from 'jquery';
import { googleMaps, events } from './google-maps';
import scrollTo from '../utils/scroll-to';

export default ({
  $map,
  $properties,
  $markers,
}, options = {},
{ shouldBindEvents = true } = {}) => {
  const $$ = {
    map: $map,
    properties: $properties,
    markers: $markers,
  };

  const markers = $$.markers.map((index, marker) => {
    const $marker = $(marker);
    const markerLat = parseFloat($marker.data('lat'));
    const markerLng = parseFloat($marker.data('lng'));
    const propertyId = parseFloat($marker.data('id'));
    const propertyName = $marker.data('property-name');
    const markerIcon = $marker.data('marker-url');

    return {
      icon: markerIcon,
      lat: markerLat,
      lng: markerLng,
      id: propertyId,
      name: propertyName,
    };
  })
    .get();

  googleMaps({
    el: $$.map[0],
    markers,
    ...options,
    fitBounds: true,
  });

  if (!shouldBindEvents) {
    return;
  }

  events.on('click', (e, { id }) => {
    const $property = $$.properties.filter((index, property) => $(property)
      .data('id') === id)
      .eq(0);

    scrollTo($property);
  });

  events.on('mouseover', (e, {
    name, marker, map, google,
  }) => {
    const infoWindow = new google.maps.InfoWindow({
      content: name,
    });

    infoWindow.open(map, marker);

    marker.addListener('mouseout', () => {
      infoWindow.close();
    });
  });
};
